export default "__VITE_ASSET__Vv4v9TQ2__"